import { Component, OnInit } from '@angular/core';
import { Role_Document, Role } from '../../model/role';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogService } from 'projects/Shared-Lib/component/dialog/dialog.service';
import { FilterDataService } from '../../services/filter-data.service';
import { DataService } from 'projects/Shared-Lib/services/data.service';

@Component({
  selector: 'app-role-edit',
  templateUrl: './role-edit.component.html',
  styleUrls: ['./role-edit.component.css']
})
export class RoleEditComponent implements OnInit {
  Doc: Role_Document;
  selectedEnabled: any;
  //NEW or edit
  DocMode: string = 'NEW';
  Title: string = 'Create';
  ControllerName = 'Role';

  constructor(private route: ActivatedRoute,
    private DlgService: DialogService, private filterService: FilterDataService,
    private router: Router, private dataService: DataService) {
    this.Doc = new Role_Document(DlgService, router, dataService);

    this.Doc.RoleName = '';
    this.Doc.SelectEnabled = 1;
  }

  ngOnInit() {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      //edit mode
      this.Doc.GetDocument(id);
      this.DocMode = "EDIT";
      this.Title = "Edit";
    }
    else {
      //create mode
      this.Title = "Create";
    }
  }

  isValid(): boolean {
    if (this.Doc.RoleName && this.Doc.RoleName !== '') {
      return false;
    }

    return true;
  }

  Submit() {
    if (this.DocMode === "NEW") {
      let postData: Role = {
        RoleId: this.Doc.RoleId,
        RoleName: this.Doc.RoleName,
        IsEnabled: this.Doc.SelectEnabled === 1
      };

      this.dataService.addData(this.ControllerName, postData, (ret) => {
        let result = this.DlgService.CreateSubmit();
        result.then((ret) => {
          if (ret === 'Back') {
            this.Cancel();
          }
          else if (ret === 'Create Another') {
            this.Doc.RoleId = '00000000-0000-0000-0000-000000000000';
            this.Doc.RoleName = '';
            this.Doc.SelectEnabled = 1;
          }
        }).catch((error) => {
          console.error(error);
        });
      });

    }
    else if (this.Doc.RoleId && this.DocMode === "EDIT") {
      let postData: Role = {
        RoleId: this.Doc.RoleId,
        RoleName: this.Doc.RoleName,
        IsEnabled: this.Doc.SelectEnabled === 1
      };
      this.dataService.updateData(`${this.ControllerName}/${postData.RoleId}`, postData, (data) => {

        let result = this.DlgService.EditSubmit();
        result.then((ret) => {
          if (ret === 'Back') {
            this.Cancel();
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  Cancel() {
    let lastPageInfo = this.filterService.GetSearchInfo();
    console.log(lastPageInfo);
    if (lastPageInfo.RouteName) {
      this.router.navigate([lastPageInfo.RouteName]);
    }
    else
      this.router.navigate(['/Auth/Role']);
  }
}
